import React from 'react';
import { Grid } from '@fiverr-private/layout_components';
import { validateAttributes, sortAttributes, AttributeData } from './utils';
import MetadataAttribute from './MetadataAttribute';

interface MetadataProps {
  metadataAttributes: AttributeData[];
}

const Metadata = ({ metadataAttributes }: MetadataProps) => {
  const sortedAttributes = sortAttributes(validateAttributes(metadataAttributes));

  if (!sortedAttributes.length) {
    return null;
  }

  return (
    <Grid
      as="ul"
      direction={{ default: 'column', sm: 'row' }}
      templateColumns={{ default: '100%', sm: '33%_33%_33%' }}
      gap="5"
      paddingTop="5"
      borderTopWidth="sm"
      borderStyle="solid"
      borderColor="grey_500"
    >
      {sortedAttributes.map(({ name, options, metadata }) => (
        <MetadataAttribute key={name} name={name} options={options} metadata={metadata} />
      ))}
    </Grid>
  );
};

export default Metadata;
